import type { BrandId } from '@nadoutong/contracts';
import { Chip } from '../ui/index.ts';
import type { ChipTone } from '../ui/index.ts';

/**
 * Display chip for a customer's brand (`accounts.signup_brand`, epic
 * #1030 E1-S4). Brand names are proper nouns, so the label is a fixed
 * registry map rather than an i18n key.
 */

export const BRAND_LABELS: Readonly<Record<BrandId, string>> = {
  nadoutong: 'Nadoutong',
  nxtpath: 'Nxtpath',
};

const BRAND_TONES: Readonly<Record<BrandId, ChipTone>> = {
  nadoutong: 'signal',
  nxtpath: 'ok',
};

export function brandLabel(brand: BrandId): string {
  return BRAND_LABELS[brand];
}

export function BrandChip({
  brand,
  testId,
}: {
  readonly brand: BrandId;
  readonly testId?: string;
}): JSX.Element {
  return (
    <Chip tone={BRAND_TONES[brand]} lamp={false} testId={testId}>
      {BRAND_LABELS[brand]}
    </Chip>
  );
}
